export const CampaignRoutes = {
  Overview: 'overview',
  Create: 'create',
  Detail: 'detail',
  AddCandidate: 'add-candidate',
} as const;
